import React, { useEffect, useState } from "react";
// nodejs library to set properties for components
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import styles from "assets/jss/material-kit-react/components/resumeStyle.js";
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Axios from "axios";
import Config from "../../config.js"
import swal from 'sweetalert'
import BeatLoader from "react-spinners/BeatLoader";
import classNames from "classnames";
import LocalPhoneOutlined from '@material-ui/icons/LocalPhoneOutlined';
import EmailOutlined from '@material-ui/icons/EmailOutlined';
import PrintOutlined from '@material-ui/icons/PrintOutlined';

const useStyles = makeStyles(styles);

export default function History(props) {
  const { id } = props

  const classes = useStyles();
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgCube,
    classes.imgProfile
  );
  let [loading, setLoading] = useState(true);
  let [data, setData] = useState(null);
  var print=function (){
    window.print();
}
  useEffect(() => {
    Axios.post(Config.api + "Resume/SharedResume", {
      code: id
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      }).then((result) => {
        setLoading(false)
        setData(result.data.data)
      }).catch((err) => {
        if (err && err.response && err.response.status && err.response.status == 422)
          swal("پارامترهای ارسالی نادرست است.");
        else if (err && err.response && err.response.data && err.response.data.fa_message) {
          swal(err.response.data.fa_message);
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }, [])
  const css = `
  .showInPrint{
    display: none;
  }
  .hiddenInPrint{
    display: block;
  }
  @media print {
    body * {
      visibility: hidden;
    }
    body {
      display: table;
      table-layout: fixed;
      padding-top: 2.5cm;
      padding-bottom: 2.5cm;
      height: auto;
  }
    .showInPrint{
    display: block;
    }
    .hiddenInPrint{
      display: none;
    }
    #section-to-print, #section-to-print *,.section-to-print, .section-to-print * {
      visibility: visible;
    }
  
    #section-to-print,.section-to-print {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
`
  return (
    <form noValidate autoComplete="off">
      <style >
      {css}
      </style>
      <GridContainer className={classes.root} justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.div}>

                <div className={classes.center + " " + classes.fastAccess}>
                  <BeatLoader loading={loading} color={"gray"} size={15} />
                </div>

                {!loading ? (
                  <div class="section-to-print" id="section-to-print">
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <div className={classes.center + " " + classes.fastAccess}>
                        <img src={data?.picture} alt={data?.name} className={imageClasses} />
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <div className={classes.center + " " + classes.topMargin}>
                        <Typography variant="button" display="block" gutterBottom>
                          {data?.name}
                        </Typography>
                        <Typography variant="overline" display="block" gutterBottom>
                          {data?.title}
                        </Typography>
                        <Typography variant="overline" display="block" gutterBottom>
                          {data?.maritalStatus ? (
                            <Chip size="small" label={data?.maritalStatus} />
                          ) : null}
                          &nbsp;
                          {data?.militaryServiceStatus ? (
                            <Chip size="small" label={data?.militaryServiceStatus} />
                          ) : null}
                          &nbsp;
                          {data?.collegian ? (
                            <Chip size="small" label={data?.collegian} />
                          ) : null}
                        </Typography>

                      </div>
                      <div className={classes.center + " " + classes.fastAccess}>
                        <Typography variant="overline" display="block" gutterBottom>
                          <div class='showInPrint'>شماره تماس: {data?.phoneNumber}</div>
                          <div  class='showInPrint'>پست الکترونیک: {data?.email}</div>
                          <div class='hiddenInPrint'>
                          <Button   className={classes.greenAncher} href={"tel:" + data?.phoneNumber}><LocalPhoneOutlined /></Button>
                          <Button  className={classes.blueAncher} href={"mailto:" + data?.email}><EmailOutlined /> </Button>
                          <Button   className={classes.yellowAncher} onClick={print}><PrintOutlined /> </Button>
                          </div>
                        </Typography>


                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <Divider />

                      <div className={classes.left + " " + classes.fastAccess}>
                        <div className={classes.together} >
                          <Typography variant="h6" gutterBottom component="div">
                            تحصیلات
                          </Typography>
                          <div class='box'>
                            <ul>
                              {data?.educations.map((education, i) => {
                                return (<li>
                                  <Typography variant="body2" gutterBottom>
                                    {education}
                                  </Typography>
                                </li>)
                              })}

                            </ul>
                          </div>
                        </div>
                        <div className={classes.together} >
                          <Typography variant="h6" gutterBottom component="div">
                            سوابق شغلی
                          </Typography>
                          <div class='box'>
                            <ul>
                              {data?.jobs.map((job, i) => {
                                return (
                                  <li> <Typography variant="body2" gutterBottom>
                                    {job}
                                  </Typography></li>)
                              })}
                            </ul>

                          </div>
                        </div>
                        <div className={classes.together} >
                          <Typography variant="h6" gutterBottom component="div">
                            مهارت‌ها
                          </Typography>
                          <div class='box'>
                            <ul>
                              {data?.skills.map((skill, i) => {
                                return (<li> <Typography variant="body2" gutterBottom>
                                  {skill}
                                </Typography></li>)
                              })}
                            </ul>
                          </div>
                        </div>
                        <div className={classes.together} >
                          <Typography variant="h6" gutterBottom component="div">
                            افتخارات
                          </Typography>
                          <div class='box'>
                            <ul>
                              {data?.honors.map((honor, i) => {
                                return (<li> <Typography variant="body2" gutterBottom>
                                  {honor}
                                </Typography></li>)
                              })}
                            </ul>
                          </div>
                        </div>
                        <div className={classes.together} id="projects">
                          <Typography variant="h6" gutterBottom component="div">
                            پروژه‌ها
                          </Typography>
                          <div class='box'>
                            <ul>
                              {data?.projects.map((project, i) => {
                                return (<li><Typography variant="body2" gutterBottom>
                                  <a className={classes.ancher}  size="small" href={project?.link == "" ? "#projects" : project.link} variant="text">{project?.name}</a><span class='showInPrint'>{project?.link == "" ? "" : " لینک پروژه: "+project.link}</span>
                                  </Typography></li>)
                              })}
                            </ul>
                          </div>
                        </div>

                        <div className={classes.together}  className={classes.center+" "+classes.topMargin}>
                          <div class='qrcode'>
                            <img src={data?.qrcode} />
                          </div>
                          <div className={classes.rtl}>
                          <Typography variant="overline" display="block" gutterBottom>
                            <a target="_blank" className={classes.ancher}  size="small" href={data?.linkedin} variant="text">{data?.linkedin}</a>
                            </Typography>
                          </div>
                        </div>
                        <div  class='showInPrint'>
                        <div className={classes.together}  className={classes.center+" "+classes.topMargin}>
                        <Divider />
                          <div >
                            <br/>
                          <Typography variant="overline" display="block" gutterBottom>
                              آدرس صفحه : HTTP://sharifcamp.ir/U/R/{id}
                            </Typography>
                          </div>
                        </div>
                        </div>
                      </div>
                    </GridItem>
                  </GridContainer>
                  </div>
                ) : null}

              </div>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </form>
  );
}